export default __webpack_public_path__ + "static/media/mp-icon-01.e5f1fa55.png";